<template>
  <div class="entity-filter">
    <div class="title-bar">
      <div class="col-lg-12 filter-container">
        <div class="sidebar-icon">
          <div class="col-lg-2">
            <i id="sidebar" class="fa fa-bars sidebar" @click="toggleSidebar"></i>
          </div>
        </div>
        
        <div class="input-group router-link-active">
          <i :class="title.icon"></i>
          <h1>{{ title.name }}</h1>
        </div>
      </div>
    </div>
    <div class="title-search">
      <div class="row">
        <div class="col-lg-9 filter-container">
          <div class="input-group">
            <input type="text" class="form-control filter-input-bar"
                   placeholder="Search"
                   v-model="query"
                   v-on:input="filterList">
          </div>
        </div>
        <div class="col-lg-3">
          <div class="input-group">
            <action-list :actions="actions" ></action-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
import AlphabetizedFilter from './AlphabetizedFilter';
import Organizer from './Organizer';
import ActionList from './ActionList';
import { bus } from '../main'


export default {
  props: {
    title: {default: "Saint Lucia NEIS"},
    searchableFields: {default: () => []},
    dataList: { default: () => ({}) },
    showAlphabetizedFilter: { default:false },
    useGroup: {default: false},
    groupByOptions: {default: () => ({})},
    actions: { default: () => []}
  },
  data() {
    return {
      query: '',
      selectedLetters: [],
      sortByOptions: {
        'modified': 'Modified',
      }
    };
  },
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
    
    toggleAdvancedFilter(){
      this.$store.dispatch('toggleAdvancedFilter');
    },
    emitFilteredItems(filteredList){
      this.$store.dispatch('updateFilteredList', filteredList);
    },
    emitClearFilter(){
      if (!this.query && !this.selectedLetters.length){
        this.$store.dispatch('clearFilteredList');
      }
    },
    filterList(){
      this.selectedLetters = [];
      if (!this.query){
        this.emitClearFilter();
        return;
      }
      let listToFilter = this.dataList;
      let filteringList = [];
      for (let field of this.searchableFields) {
        let matchedCustomers = listToFilter.filter(
          c => new RegExp(this.query,'gi').test(c[field])
        );
        matchedCustomers = matchedCustomers.map(c => c.id);
        filteringList = filteringList.concat(matchedCustomers);
      }
      this.emitFilteredItems(filteringList);
    },
    filterByAlphabet(letters, searchField){
      this.query = '';
      if (!this.selectedLetters){
        this.emitClearFilter();
        return;
      }
      let listToFilter = this.dataList;
      let filteringList = [];
      for (let letter of letters){
        let pattern = new RegExp('^' + letter, 'i');
        filteringList = filteringList
          .concat(listToFilter
            .filter(c => pattern.exec(c[searchField])));
      }
      filteringList = filteringList.map( c => c.id);
      this.emitFilteredItems(filteringList);
    },
  },
  components: {
    AlphabetizedFilter,
    Organizer,
    ActionList
  }
};
</script>


<style lang="scss" scoped>
@import "../css/constants";
.sidebar-icon { 
  display: none; 
  float: none;
  i { 
    cursor: pointer;
    &:hover {
      color: #f1f1f1;
    }
  }
}

.title-search:after { float: clear; display: table; content: ""; }
.title-search{ float: right; width: 45%; padding: 0; margin-right: -0px; }
.title-bar{ 
  float: left; 
  margin-top: 6px; 
  .router-link-active { 
    i { margin-top: 2px; padding: 7.6px; }
  }
}

.entity-filter:after { content: ""; display: table; clear: both; }
.entity-filter{ 
  height: auto; 
  margin: 0 -25px $p30 -25px;
  padding: 14px 0 10px 40px;
  
  
  // border-bottom: 1px solid #dedede;
  background-color: #06bafc;
  color: white;
}
.organizer-container{ padding-right:0px!important; }
.row{ margin: 0; padding: 0; }    
.filter-container{ padding-left:0px!important; }

.input-group {
  display: flex;
  flex-direction: row; 
  
  input{
    border: none;
    background-color: #f3f3f3;
  }
}

button.advanced-search {
  height: $p32;
  border: 1px solid $gray4;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-image: url('../assets/advanced-search.svg');
  background-position: 124px 9px;
  background-repeat: no-repeat;
  background-color: white;
  font-size: $p14;
  white-space: nowrap;
  padding-left: $p12;
  color:grey;
  padding-top: 3px;
  padding-right: $p32;
  &:focus {
    outline: none;
  }
}
.col-lg-10{ margin: 0px; }
.col-lg-9 { margin: 0; padding: 0 !important}
.input-group-addon{
  padding: 0.25rem 0.1rem; 
}

.filter-input-bar{
  padding-left: 38px;
  background-image: url('../assets/search-small.svg');
  background-repeat: no-repeat;
  background-position: 14px 9px;
  margin: 0;
  border: none;
  height: $p32;
  border: 1px solid $gray4;
  box-shadow: none;

  &:focus {
    outline: none;
  }
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  .title-bar { 
    width: 50%;
    
    .col-lg-12 { 
      .router-link-active {
        h1 {
          width: 100%;
          height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  
  .title-search { 
      width: 50%;
      
      .row:after { float: clear; display: table; content: ""; }
      .row {
        margin: 0px;
        
        .input-group { display: inline !important; }   
        .col-lg-9 { width: 70%; padding: 0; margin: 0; }
        .col-lg-3 { width: 30%; float: right; margin-top: -3px; }          
      }
   }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  .title-bar { 
    width: 35%;
    
    .col-lg-12 { 
      // margin-left: 20px;
      .router-link-active {
        h1 { 
          width: 100%; 
          height: 25px; 
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        i { display: none; } 
      }
    }
  }
  
  .title-search { 
      width: 65%;
      display: inline-block;
        
      .row:after { float: clear; display: table; content: ""; }
      .row {
        margin: 0px;
        
        .input-group { display: inline !important; }   
        .col-lg-9 { width: 60%; padding: 0; margin: 0; }
        .col-lg-3 { width: 40%; float: right; margin-top: -3px; }          
      }
   }
     
   .sidebar-icon {
     float: left; 
     display: inline-block;
     margin-left: 0px; 
     padding-left: 0px;
     i { font-size: 1.4em; margin: 0; margin-right: 2px; margin-top: -3px; }
   }
}

@media only screen and (max-width: 468px) {
  /* For mobile phones: */
  .title-bar { 
    display: inline-block;
    width: 60%;
    
    .col-lg-12 { 
      // margin-left: 20px;
      .router-link-active {
        h1 { 
          width: 100%; 
          height: 25px; 
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        i { display: none; } 
      }
    }
  }
  
  .title-search:after { float: clear; display: table; content: ""; }
  .title-search { 
    display: inline-block;
    width: 40%; 
    
    .row:after { float: clear; display: table; content: ""; }
    .row {  
      margin: 0px;
      
      .input-group { display: inline !important; }
        
      .col-lg-9 { display: none; }
      .col-lg-3 { width: 100%; float: right; }
    }
   }
     
   .sidebar-icon {
     float: left; 
     display: inline-block;
     margin-left: 0px; 
     padding-left: 0px;
     i { font-size: 1.4em; margin: 0; margin-right: 2px; margin-top: -3px; }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/EntityFilter.vue